import React from "react";
import Departments from "./Departments";

const DepartmentsPage = () => {
  return <Departments />;
};

export default DepartmentsPage;

